import { URI } from '~/types/adamTypes';
import { getServices } from '~/db/services';

export const useAppEventsExport = () => {
  const { $db } = useNuxtApp();
  const { appEvents } = useAppEventsSyncGet();
  const processing = ref<boolean>(false);
  const focused = useWindowFocus();
  const { appEventsService } = getServices($db);
  const process = async () => {
    // check if focus to be sure to not send mulitple times by other tabs.
    if (!focused.value) return;
    try {
      processing.value = true;
      const chunkSize = 30000;
      const chunks = [];
      const appEventsUsed = [...appEvents.value];
      for (let i = 0; i < appEventsUsed.length; i += chunkSize) {
        chunks.push(appEventsUsed.slice(i, i + chunkSize));
      }
      const getChunksPromise = async (chunk): Promise<void> => {
        const chunkCleaned = chunk.map((item) => {
          const itemCleaned = { ...item };
          delete itemCleaned.id;
          return itemCleaned;
        });

        await useApiFetch(URI.MultiAppEvents, {
          method: 'POST',
          body: chunkCleaned,
        });
        const ids = chunk.map((c) => c.id);
        await appEventsService.deleteByIds(ids);
      };
      const getPromises = (): Promise<void>[] => {
        const promises = [];
        chunks.forEach((chunk) => {
          promises.push(getChunksPromise(chunk));
        });
        return promises;
      };
      await Promise.all(getPromises());
      processing.value = false;
    } catch (e) {
      processing.value = false;
    }
  };

  const unwatch = watch(
    () => appEvents.value?.length ?? 0,
    (length) => {
      if (length >= 0 && !processing.value) process();
    }
  );

  const forceProcess = async (quit: boolean = false) => {
    if (quit) unwatch();
    if (processing.value) {
      await process();
    }
  };

  return {
    forceProcess,
  };
};
